import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import FaceIcon from "@material-ui/icons/Face";
import { tesaWhite } from "../../styles/colors";

const useStyles = makeStyles(() => {
  return {
    root: {
      justifyContent: "center",
      backgroundColor: tesaWhite,
      borderRadius: "18px",
      boxSizing: "border-box",
      display: "inline-block",
      fontSize: "12px",
      lineHeight: "12px",
      minWidth: "0px",
      padding: "4px 8px 6px 8px",
    },
    faceIcon: {
      height: "13px",
      width: "13px",
      marginRight: "6px",
      transform: "translateY(3px)",
    },
  };
});

interface UserChipProps {
  className?: string;
  userName: string;
}

const UserChip = (props: UserChipProps) => {
  const classes = useStyles(props);
  const { className, userName } = props;

  return (
    <div className={[classes.root, className].join(" ")}>
      <FaceIcon className={classes.faceIcon} />
      <span>{userName}</span>
    </div>
  );
};

export default UserChip;
